import { render, staticRenderFns } from "./AddBankCardDialog.vue?vue&type=template&id=3c449202&scoped=true&lang=pug&"
import script from "./AddBankCardDialog.vue?vue&type=script&lang=ts&"
export * from "./AddBankCardDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c449202",
  null
  
)

export default component.exports